import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';

import { Pressure as PressureAction } from '~/actions';
import { PressureSimulate, PressureFilters } from '~/components';
import ContentData from '~/hoc/ContentData';
import { Content } from '~/containers/styles';
import moment from '~/_moment';

class PressureSimulation extends Component {
  UNSAFE_componentWillMount() {
    this.props.loadPressure();
  }

  componentWillUnmount() {
    this.props.resetPressure();
  }

  render() {
    const {
      pressure,
      profile,
      handleChangeDate,
      handleChangeStartTime,
      handleChangeEndTime,
      loadPressure,
    } = this.props;

    const {
      site_name: siteName,
      pressure: { enable: isPressureEnable, dam_section: damSection },
    } = profile;

    return (
      isPressureEnable && (
        <Content>
          <Helmet>
            <title>ระบบจำลองแรงดันภายในตัวเขื่อน</title>
          </Helmet>
          <ContentData
            isLoading={pressure.isloading || !profile.hasLoaded}
            title="ระบบจำลองแรงดันภายในตัวเขื่อน"
          >
            <div className="container">
              <div className="row">
                <div className="col-xs-12">
                  <PressureFilters
                    showTimePicker
                    siteName={siteName}
                    dateFormat="YYYY-MM-DD"
                    timeFormat="HH:mm"
                    dateValue={pressure.date}
                    startTimeValue={pressure.startTime}
                    endTimeValue={pressure.endTime}
                    isPressureloading={pressure.isloading}
                    handleLoadData={loadPressure}
                    handleChangeDate={handleChangeDate}
                    handleChangeStartTime={handleChangeStartTime}
                    handleChangeEndTime={handleChangeEndTime}
                    disabledDate={moment(profile.firstRun).subtract(1, 'days')}
                    enableDownloadCSV={true}
                  />

                  <PressureSimulate
                    damSectionImage={damSection}
                    pressureData={pressure}
                    isLoading={pressure.isloading}
                  />
                </div>
              </div>
            </div>
          </ContentData>
        </Content>
      )
    );
  }
}

export default connect(
  ({ DamProfile, Pressure }) => ({
    profile: DamProfile,
    pressure: Pressure,
  }),
  {
    handleChangeDate: PressureAction.changeDate,
    handleChangeStartTime: PressureAction.changeStartTime,
    handleChangeEndTime: PressureAction.changeEndTime,
    loadPressure: PressureAction.loadPressureData,
    resetPressure: PressureAction.resetPressureData,
  },
)(PressureSimulation);



// WEBPACK FOOTER //
// ./resources/assets/js/containers/PressureSimulation/PressureSimulation.js